import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import {
  doCreateSubZone,
  doUpdateSubZone,
  doDetailSubZone,
  doDeleteSubZone,
} from "./thunk";

const subZonesAdapter = createEntityAdapter({
  selectId: (item) => item._id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const subZoneSlice = createSlice({
  name: "subZone",
  initialState: {
    isFetching: false,
    status: "idle",
    metadata: {},
    entities: [],
    item: null,
    ids: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doCreateSubZone.pending, (state) => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doCreateSubZone.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
    });
    builder.addCase(doCreateSubZone.rejected, (state) => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doUpdateSubZone.pending, (state) => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doUpdateSubZone.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
    });
    builder.addCase(doUpdateSubZone.rejected, (state) => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doDetailSubZone.pending, (state) => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doDetailSubZone.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      state.item = action.payload;
    });
    builder.addCase(doDetailSubZone.rejected, (state) => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doDeleteSubZone.pending, (state) => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doDeleteSubZone.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      state.message = action.payload.message;
    });
    builder.addCase(doDeleteSubZone.rejected, (state) => {
      state.isFetching = false;
      state.status = "failed";
    });
  },
});

export const {
  selectAll: selectAllLocations,
  selectById: selectLocationById,
  selectIds: selectLocationIds,
} = subZonesAdapter.getSelectors((state) => state.subZone);

const { reducer: subZoneReducer } = subZoneSlice;
export default subZoneReducer;
